/**
 * Different modes of Firebase Emails
 */
const EmailMode = {
  resetPassword: "resetPassword",
  verifyEmail: "verifyEmail"
};

export default EmailMode;
